import React from "react";

export function LoaderFiller() {
  return (
    <div
      className={
        "w-full h-full absolute top-0 left-0 flex items-center bg-white justify-center"
      }
      style={{ zIndex: 100000, opacity: 0.7 }}
    >
      <span className={"fa fa-spinner fa-spin"} />
    </div>
  );
}
